import { useCallbackObservable, useObservable } from 'react-use-observable';

import { Alert, Button, Modal, Typography } from 'antd';

import ordersService from 'v2/services/orders';

import List from './list';

const ModalTrackingCodes = () => {
  const [open] = useObservable(() => ordersService.getModalTrackingCodes(), []);
  const [closeModal] = useCallbackObservable(() => ordersService.closeModalTrackingCodes(), []);

  return (
    <Modal
      width={1024}
      open={!!open}
      onCancel={closeModal}
      destroyOnHidden
      title='Status dos pedidos: AGUARDANDO ENVIO'
      footer={
        <div className='flex justify-end'>
          <Button type='primary' onClick={closeModal}>
            Fechar
          </Button>
        </div>
      }
    >
      <div className='flex flex-col gap-4'>
        <Alert
          type='warning'
          showIcon
          message={
            <>
              Ao enviar o código de rastreio o status da entrega será atualizado para{' '}
              <Typography.Text strong>ENVIADO</Typography.Text> automaticamente.
            </>
          }
        />
        {open && <List />}
      </div>
    </Modal>
  );
};
export default ModalTrackingCodes;
